import { GET_PROFILE_DATA, PROFILE_LOADING, SET_PROFILE_DATA } from '../ActionsTypes';

const getProfileDataAction = (data) => ({
  type: GET_PROFILE_DATA,
  payload: data,
});

const setProfileDataAction = (data) => ({
  type: SET_PROFILE_DATA,
  payload: data,
});

const setProfileLoadingAction = (data) => ({
  type: PROFILE_LOADING,
  payload: data,
});

const setResetProfileAction = () => ({
  type: SET_PROFILE_DATA,
  payload: null,
});

export { getProfileDataAction, setProfileLoadingAction, setProfileDataAction, setResetProfileAction };
